import { render, staticRenderFns } from "./MonthPayerGroup.vue?vue&type=template&id=48e85780&"
import script from "./MonthPayerGroup.vue?vue&type=script&lang=js&"
export * from "./MonthPayerGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports